export var accessRights = [
  {
    label: 'AGIS',
    name:'AGIS',
    admin: {
      key: 'AGIS_ADMIN',
      label: 'User Type',
      levels: [{
        name: 'User',
        value: 1
      },{
        name: 'Admin',
        value: 4
      }],
    },
    subsystems: []
  },
  {
    label: 'APS',
    name: "PAVE",
    admin: {
      key: 'PAVE_ADMIN',
      label: 'User Level',
      levels: [{
        name: 'User',
        value: 1
      },{
        name: 'Admin',
        value: 4
      }],
    },
    subsystems: [
      {
        key: 'PAVE_RESURFACING',
        label: 'Resurfacing',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'PAVE_AGE',
        label: 'Pavement Age',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'PAVE_CORE_RECORDS',
        label: 'Core Records',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'PAVE_DEFECTS',
        label: 'Defect Log',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'PAVE_HEAVING',
        label: 'Heaving',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'PAVE_MAINTENANCE',
        label: 'Maintenance',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'PAVE_PCI',
        label: 'PCI',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'PAVE_PCN',
        label: 'PCN',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      }
    ]
  },
  {
    label: 'PWSS',
    name: "POT",
    admin: {
      key: 'POT_ADMIN',
      label: 'User Level',
      levels: [{
        name: 'User',
        value: 1
      },{
        name: 'Admin',
        value: 4
      }],
    },
    subsystems: [
      {
        key: 'POT_NETWORK',
        label: 'Water Network',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'POT_LEAKAGE',
        label: 'Leakage Detection',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'POT_INTAKE',
        label: 'Intake',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'POT_SIMULATION',
        label: 'Simulation',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'POT_ASSET_AGE',
        label: 'Asset age',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'POT_MAINTENANCE',
        label: 'Maintenance',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'POT_INSPECTION',
        label: 'Inspection',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'POT_AAMS',
        label: 'AAMS Asset',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
    ]
  },
  {
    label: 'HMLS',
    name: 'HML',
    admin: {
      key: 'HML_ADMIN',
      label: 'User Level',
      levels: [{
        name: 'User',
        value: 1
      },{
        name: 'Admin',
        value: 4
      }],
    },
    subsystems: [
        {
          key: 'HML_NETWORK',
          label: 'HML Network',
          currentLevel: null,
          availableLevels: [{
              name: "Denied",
              value: 0
            },
            {
              name: "Viewer",
              value: 1
            },
            {
              name: "Adv. Viewer",
              value: 2
            },
            {
              name: "Editor",
              value: 3
            },
            {
              name: "Admin",
              value: 4
            },
          ]
        },{
          key: 'HML_LUX',
          label: 'Lux Measurement',
          currentLevel: null,
          availableLevels: [{
              name: "Denied",
              value: 0
            },
            {
              name: "Viewer",
              value: 1
            },
            {
              name: "Adv. Viewer",
              value: 2
            },
            {
              name: "Editor",
              value: 3
            },
            {
              name: "Admin",
              value: 4
            },
          ]
        },
        {
          key: 'HML_POWER_SOURCE',
          label: 'Power Source',
          currentLevel: null,
          availableLevels: [{
              name: "Denied",
              value: 0
            },
            {
              name: "Viewer",
              value: 1
            },
            {
              name: "Adv. Viewer",
              value: 2
            },
            {
              name: "Editor",
              value: 3
            },
            {
              name: "Admin",
              value: 4
            },
          ]
        },
        {
          key: 'HML_AIRCRAFT',
          label: 'Aircraft Earth Receptacle',
          currentLevel: null,
          availableLevels: [{
              name: "Denied",
              value: 0
            },
            {
              name: "Viewer",
              value: 1
            },
            {
              name: "Adv. Viewer",
              value: 2
            },
            {
              name: "Editor",
              value: 3
            },
            {
              name: "Admin",
              value: 4
            },
          ]
        },
        {
          key: 'HML_AAMS',
          label: 'AAMS Asset',
          currentLevel: null,
          availableLevels: [{
              name: "Denied",
              value: 0
            },
            {
              name: "Viewer",
              value: 1
            },
            {
              name: "Adv. Viewer",
              value: 2
            },
            {
              name: "Editor",
              value: 3
            },
            {
              name: "Admin",
              value: 4
            },
          ]
        },
      ]
  },
  {
    label: 'AGLS',
    name: "AGL",
    admin: {
      key: 'AGL_ADMIN',
      label: 'User Level',
      levels: [{
        name: 'User',
        value: 1
      },{
        name: 'Admin',
        value: 4
      }],
    },
    subsystems: [
      {
        key: 'AGL_ASSET',
        label: 'Asset',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'AGL_REPLACEMENT',
        label: 'Replacement',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'AGL_BOLT',
        label: 'Bolt Inspection',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'AGL_EPOXY',
        label: 'Epoxy Inspection',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'AGL_PHOTOMETRIC',
        label: 'Photometric',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'AGL_AAMS',
        label: 'AAMS Asset',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
    ]
  },
  {
    label: 'SS',
    name: "SS",
    admin: {
      key: 'SS_ADMIN',
      label: 'User Level',
      levels: [{
        name: 'User',
        value: 1
      },{
        name: 'Admin',
        value: 4
      }],
    },
    subsystems: [
      {
        key: 'SS_ASSET',
        label: 'Asset',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'SS_RELINING',
        label: 'Relining',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'SS_CCTV',
        label: 'CCTV',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'SS_MAINTENANCE',
        label: 'Maintenance',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'SS_SIMULATION',
        label: 'Simulation',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
      {
        key: 'SS_AAMS',
        label: 'AAMS Asset',
        currentLevel: null,
        availableLevels: [{
            name: "Denied",
            value: 0
          },
          {
            name: "Viewer",
            value: 1
          },
          {
            name: "Adv. Viewer",
            value: 2
          },
          {
            name: "Editor",
            value: 3
          },
          {
            name: "Admin",
            value: 4
          },
        ]
      },
    ]
  }
];
export var SecurityKeys = {
  AGIS_ADMIN: 'AGIS_ADMIN',
  PAVE_ADMIN: 'PAVE_ADMIN',
  PAVE_RESURFACING: 'PAVE_RESURFACING',
  PAVE_AGE: 'PAVE_AGE',
  PAVE_CORE_RECORDS: 'PAVE_CORE_RECORDS',
  PAVE_DEFECTS: 'PAVE_DEFECTS',
  PAVE_HEAVING: 'PAVE_HEAVING',
  PAVE_MAINTENANCE: 'PAVE_MAINTENANCE',
  PAVE_PCI: 'PAVE_PCI',
  PAVE_PCN: 'PAVE_PCN',
  POT_ADMIN: 'POT_ADMIN',
  POT_NETWORK: 'POT_NETWORK',
  POT_LEAKAGE: 'POT_LEAKAGE',
  POT_INTAKE: 'POT_INTAKE',
  POT_SIMULATION: 'POT_SIMULATION',
  POT_ASSET_AGE: 'POT_ASSET_AGE',
  POT_MAINTENANCE: 'POT_MAINTENANCE',
  POT_INSPECTION: 'POT_INSPECTION',
  HML_ADMIN: 'HML_ADMIN',
  HML_NETWORK: 'HML_NETWORK',
  HML_LUX: 'HML_LUX',
  HML_POWER_SOURCE: 'HML_POWER_SOURCE',
  HML_AIRCRAFT: 'HML_AIRCRAFT',
  AGL_ADMIN: 'AGL_ADMIN',
  AGL_ASSET: 'AGL_ASSET',
  AGL_REPLACEMENT: 'AGL_REPLACEMENT',
  AGL_BOLT: 'AGL_BOLT',
  AGL_EPOXY: 'AGL_EPOXY',
  AGL_PHOTOMETRIC: 'AGL_PHOTOMETRIC',
  SS_ADMIN: 'SS_ADMIN',
  SS_ASSET: 'SS_ASSET',
  SS_RELINING: 'SS_RELINING',
  SS_CCTV: 'SS_CCTV',
  SS_MAINTENANCE: 'SS_MAINTENANCE',
  SS_SIMULATION: 'SS_SIMULATION',
}



// WEBPACK FOOTER //
// ./src/service/accessRights.js